import { createElement, FC } from 'react';

import DummyContent from '../primitive/DummyContent';

interface Props {
  className?: string;
}

const DummyWideContent: FC<Props> = ({ className }) => (
  <div className={className}>
    <DummyContent size="body2" length={175} />
  </div>
);

export default DummyWideContent;
